// li-funnel-redesign v2 — checkout routes. Only the plans page lives under the
// variant prefix; the payment page is mounted at /checkout/payment by the
// variant-switching wrapper because the shared subscription action redirects
// there directly.

import {
  createStripeSubscriptionAction,
  getPricesLoader,
} from '@app-studio-web/ui/pages/checkout/checkoutRoutes'
import { Outlet } from 'react-router-dom'
import PlansPage from './PlansPage'

const v2CheckoutRoutes = [
  {
    path: 'v2',
    element: <Outlet />,
    children: [
      {
        action: createStripeSubscriptionAction,
        element: <PlansPage />,
        loader: getPricesLoader,
        path: 'plans',
      },
    ],
  },
]

export default v2CheckoutRoutes
